
import React, { Fragment, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as Error } from "../../assets/utils/images/svgs/ErrorPage.svg";

const ErrorPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const userRoles = useSelector(
        (state) => state.UserPermission?.roles ?? []
    );


useEffect(() => {
    const previousPath = location.state?.previousPath;

    const isCoordinatorRoute =
        previousPath?.startsWith("/verzoeken/overzicht");

    const isMelderRoute =
        previousPath === "/verzoeken" ||
        (
            previousPath?.startsWith("/verzoeken/") &&
            !isCoordinatorRoute
        );

    const timer = setTimeout(() => {
        if (isMelderRoute) {
            navigate("/verzoeken", { replace: true });
        } else {
            
            navigate("/login", { replace: true });
        }
    }, 4000);

    return () => clearTimeout(timer);
}, [navigate, location.state]);


useEffect(() => {
    const { previousPath, errorType } = location.state || {};

    const isCoordinatorVerzoeken =
        previousPath?.startsWith("/verzoeken/overzicht");

    const isMelderDetail =
        previousPath?.startsWith("/verzoeken/") &&
        previousPath !== "/verzoeken" &&
        !isCoordinatorVerzoeken;

    const timer = setTimeout(() => {
        if (errorType !== "invalid_link" || !previousPath) {
            navigate("/login", { replace: true });
            return;
        }

        if (isMelderDetail) {
            // Broken Melder detail: avoid reopening the invalid request.
            navigate("/verzoeken", { replace: true });
        } else {
            // Coordinator Verzoeken, Reiskosten, and other panels:
            // return to the exact previous URL.
            navigate(previousPath, { replace: true });
        }
    }, 4000);

    return () => clearTimeout(timer);
}, [navigate, location.state]);



    return (
        <Fragment>
            <div className="position-absolute top-50 start-50 translate-middle">
                <div className="fs-3 fw-bolder">
                    <Error />
                </div>
            </div>
        </Fragment>
    );
};

export default ErrorPage;
